import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "space-y-8 divide-y divide-gray-200" };
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" };
const _hoisted_3 = { class: "space-y-6 pt-8 sm:space-y-5 sm:pt-10" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "User Details")
], -1);
const _hoisted_5 = { class: "space-y-6 sm:space-y-5" };
const _hoisted_6 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    for: "first-name",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "First name(s) *", -1);
const _hoisted_8 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "text-red-600" };
const _hoisted_11 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", {
    for: "last-name",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Last name *", -1);
const _hoisted_13 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { class: "text-red-600" };
const _hoisted_16 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", {
    for: "userID",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "User ID *", -1);
const _hoisted_18 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_19 = { key: 0 };
const _hoisted_20 = { class: "text-red-600" };
const _hoisted_21 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", {
    for: "email",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Email address *", -1);
const _hoisted_23 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { class: "text-red-600" };
const _hoisted_26 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", {
    for: "email",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Job Title *", -1);
const _hoisted_28 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_29 = { key: 0 };
const _hoisted_30 = { class: "text-red-600" };
const _hoisted_31 = {
    role: "group",
    "aria-labelledby": "label-email-prefs",
    class: "sm:border-t sm:border-gray-200"
};
const _hoisted_32 = { class: "sm:grid sm:grid-cols-3 sm:items-baseline sm:gap-4" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", {
        id: "label-email-prefs",
        class: "text-base font-medium text-gray-900 sm:text-sm sm:text-gray-700"
    }, "Roles *")
], -1);
const _hoisted_34 = { class: "sm:col-span-2" };
const _hoisted_35 = { class: "max-w-lg" };
const _hoisted_36 = { class: "mt-4 space-y-4" };
const _hoisted_37 = {
    role: "group",
    "aria-labelledby": "label-email-prefs",
    class: "sm:border-t sm:border-gray-200"
};
const _hoisted_38 = { class: "sm:grid sm:grid-cols-3 sm:items-baseline sm:gap-4" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", {
        id: "label-email-prefs",
        class: "text-base font-medium text-gray-900 sm:text-sm sm:text-gray-700"
    }, "Email Preferences *")
], -1);
const _hoisted_40 = { class: "sm:col-span-2" };
const _hoisted_41 = { class: "max-w-lg" };
const _hoisted_42 = { class: "mt-4 space-y-4" };
const _hoisted_43 = { key: 0 };
const _hoisted_44 = { class: "text-red-600" };
const _hoisted_45 = { class: "flex items-center" };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("label", {
    for: "pref-no-emails",
    class: "ml-3 block text-sm font-medium text-gray-700"
}, "NO EMAILS", -1);
const _hoisted_47 = { class: "flex items-center" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("label", {
    for: "pref-instant",
    class: "ml-3 block text-sm font-medium text-gray-700"
}, "INSTANT", -1);
const _hoisted_49 = {
    key: 0,
    class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
};
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("label", {
    for: "archived",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Archive user", -1);
const _hoisted_51 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_52 = { class: "pt-5" };
const _hoisted_53 = { class: "flex justify-end" };
const _hoisted_54 = { class: "flex" };
const _hoisted_55 = ["disabled"];
import useVuelidate from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import CheckList from '@/components/CheckList.vue';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserForm',
    props: {
        existingUser: {}
    },
    emits: ["cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const formData = reactive({
            firstName: '',
            surname: '',
            userID: '',
            email: '',
            jobTitle: '',
            roles: [],
            emailPrefs: '',
            archived: false,
        });
        const roles = ['ADMIN', 'H2R', 'HM', 'HROPS', 'RESOURCING'];
        const userExists = ref(!!props.existingUser);
        const rules = {
            formData: {
                firstName: { required },
                surname: { required },
                userID: { required },
                email: { required, email },
                jobTitle: { required },
                roles: { required },
                emailPrefs: { required },
            },
        };
        const v$ = useVuelidate(rules, { formData });
        const handleCreateUser = async () => {
            store.dispatch('setIsLoading', true);
            try {
                const response = await httpClient.post('/users/add-user', formData);
                if (response.data.statusCode === 500)
                    throw new Error();
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: 'Successfully created new user.',
                });
                emit('cancel');
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'Could not create new user at this time.',
                });
            }
            store.dispatch('setIsLoading', false);
        };
        onMounted(() => {
            if (props.existingUser) {
                Object.assign(formData, props.existingUser);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_8, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "first-name",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.firstName) = $event)),
                                        type: "text",
                                        name: "first-name",
                                        class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                        onBlur: _cache[1] || (_cache[1] = ($event) => (_unref(v$).formData.firstName.$touch()))
                                    }, null, 544), [
                                        [_vModelText, formData.firstName]
                                    ]),
                                    _createTextVNode(),
                                    (_unref(v$).formData.firstName.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createElementVNode("p", _hoisted_10, "* " + _toDisplayString(_unref(v$).formData.firstName.$errors[0].$message), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_13, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "last-name",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formData.surname) = $event)),
                                        type: "text",
                                        name: "last-name",
                                        class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (_unref(v$).formData.surname.$touch()))
                                    }, null, 544), [
                                        [_vModelText, formData.surname]
                                    ]),
                                    _createTextVNode(),
                                    (_unref(v$).formData.surname.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createElementVNode("p", _hoisted_15, "* " + _toDisplayString(_unref(v$).formData.surname.$errors[0].$message), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_18, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "email",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((formData.userID) = $event)),
                                        name: "userID",
                                        type: "text",
                                        class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (_unref(v$).formData.userID.$touch()))
                                    }, null, 544), [
                                        [_vModelText, formData.userID]
                                    ]),
                                    _createTextVNode(),
                                    (_unref(v$).formData.userID.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createElementVNode("p", _hoisted_20, "* " + _toDisplayString(_unref(v$).formData.userID.$errors[0].$message), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_23, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "email",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((formData.email) = $event)),
                                        name: "email",
                                        type: "email",
                                        class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                        onBlur: _cache[7] || (_cache[7] = ($event) => (_unref(v$).formData.email.$touch()))
                                    }, null, 544), [
                                        [_vModelText, formData.email]
                                    ]),
                                    _createTextVNode(),
                                    (_unref(v$).formData.email.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _createElementVNode("p", _hoisted_25, "* " + _toDisplayString(_unref(v$).formData.email.$errors[0].$message), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_28, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "job-title",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((formData.jobTitle) = $event)),
                                        name: "jobTitle",
                                        type: "text",
                                        class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                        onBlur: _cache[9] || (_cache[9] = ($event) => (_unref(v$).formData.email.$touch()))
                                    }, null, 544), [
                                        [_vModelText, formData.jobTitle]
                                    ]),
                                    _createTextVNode(),
                                    (_unref(v$).formData.jobTitle.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                            _createElementVNode("p", _hoisted_30, "* " + _toDisplayString(_unref(v$).formData.jobTitle.$errors[0].$message), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                                _createVNode(CheckList, {
                                                    options: roles,
                                                    error: _unref(v$).formData.roles.$error ? _unref(v$).formData.roles.$errors[0].$message : undefined,
                                                    "model-value": formData.roles,
                                                    onBlur: _cache[10] || (_cache[10] = ($event) => (_unref(v$).formData.roles.$touch()))
                                                }, null, 8, ["error", "model-value"])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                    _hoisted_39,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                            _createElementVNode("div", _hoisted_42, [
                                                (_unref(v$).formData.emailPrefs.$error)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                        _createElementVNode("p", _hoisted_44, "* " + _toDisplayString(_unref(v$).formData.emailPrefs.$errors[0].$message), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_45, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "pref-no-emails",
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((formData.emailPrefs) = $event)),
                                                        value: "NO-EMAILS",
                                                        name: "emailPrefs",
                                                        type: "radio",
                                                        class: "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500",
                                                        onBlur: _cache[12] || (_cache[12] = ($event) => (_unref(v$).formData.emailPrefs.$touch()))
                                                    }, null, 544), [
                                                        [_vModelRadio, formData.emailPrefs]
                                                    ]),
                                                    _createTextVNode(),
                                                    _hoisted_46
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_47, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "pref-instant",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((formData.emailPrefs) = $event)),
                                                        value: "INSTANT",
                                                        name: "emailPrefs",
                                                        type: "radio",
                                                        class: "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500",
                                                        onBlur: _cache[14] || (_cache[14] = ($event) => (_unref(v$).formData.emailPrefs.$touch()))
                                                    }, null, 544), [
                                                        [_vModelRadio, formData.emailPrefs]
                                                    ]),
                                                    _createTextVNode(),
                                                    _hoisted_48
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            (userExists.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    _hoisted_50,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_51, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "archived",
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((formData.archived) = $event)),
                                            type: "checkbox",
                                            name: "archived",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed"
                                        }, null, 512), [
                                            [_vModelCheckbox, formData.archived]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:underline",
                                onClick: _cache[16] || (_cache[16] = ($event) => (_ctx.$emit('cancel')))
                            }, "Cancel"),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                disabled: _unref(v$).$invalid,
                                type: "submit",
                                class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _withModifiers(handleCreateUser, ["prevent"])
                            }, "Save", 8, _hoisted_55)
                        ])
                    ])
                ])
            ]));
        };
    }
});
